import { articles } from './articles';
import { categories } from './categories';

export const homeContent = {
  hero: {
    title: '亚洲专区',
    subtitle: '精选亚洲内容一站汇聚',
    description: '汇聚亚洲各地精选优质内容，涵盖亚洲文化、娱乐、资讯、产品与服务。探索东亚、东南亚与南亚的无限可能。',
    cta: '探索亚洲',
    secondaryCta: '了解更多',
  },
  stats: [
    { value: '12,800+', label: '精选文章' },
    { value: '8', label: '内容分类' },
    { value: '50万+', label: '月活读者' },
    { value: '30+', label: '国家地区' },
  ],
  featuredArticles: articles.filter((a) => a.featured),
  hotArticles: articles.filter((a) => a.hot).slice(0, 6),
  latestArticles: articles.slice(0, 6),
  categories,
  columns: [
    {
      title: '深度报道',
      description: '资深编辑团队深入亚洲各地，带来第一手的深度内容报道',
      icon: 'ri-pen-nib-line',
      color: 'primary' as const,
    },
    {
      title: '文化观察',
      description: '从传统到现代，解读亚洲多元文化的演变与交融',
      icon: 'ri-eye-line',
      color: 'accent' as const,
    },
    {
      title: '产品评测',
      description: '专业团队实测亚洲优质产品，提供客观的购买建议',
      icon: 'ri-star-line',
      color: 'secondary' as const,
    },
    {
      title: '旅行指南',
      description: '跟着我们的脚步，发现亚洲最值得探索的目的地',
      icon: 'ri-map-pin-line',
      color: 'primary' as const,
    },
  ],
  faqs: [
    {
      question: '亚洲专区提供哪些地区的内容？',
      answer: '亚洲专区覆盖东亚（中国、日本、韩国等）、东南亚（泰国、越南、新加坡、马来西亚、印尼、菲律宾等）以及南亚（印度、不丹、尼泊尔、斯里兰卡等）三大区域，为您提供最全面的亚洲内容汇总。',
    },
    {
      question: '亚洲专区的内容更新频率是怎样的？',
      answer: '我们每天更新精选内容，每周推出深度专题报道，确保您始终能获取最新、最优质的亚洲资讯、文化、娱乐和产品信息。',
    },
    {
      question: '如何快速找到我感兴趣的亚洲内容？',
      answer: '您可以通过首页的分类导航进入不同主题专区，也可以使用搜索功能查找特定关键词。每个分类页面都支持按地区、主题和时间进行筛选，帮助您快速定位感兴趣的内容。',
    },
    {
      question: '亚洲专区的内容来源是否可靠？',
      answer: '我们的内容由专业的编辑团队采编和审核，所有信息均来源于权威渠道。深度报道由资深记者实地采访完成，确保内容的真实性和权威性。',
    },
    {
      question: '我可以在亚洲专区投稿吗？',
      answer: '当然可以！我们欢迎对亚洲文化、资讯、产品和服务有深入了解的作者投稿。您可以通过"关于我们"页面的联系方式提交您的稿件或选题建议，我们的编辑团队会及时回复。',
    },
    {
      question: '亚洲专区是否有移动端应用？',
      answer: '亚洲专区网站采用响应式设计，在手机、平板和桌面端都有良好的浏览体验。您可以将网站添加到手机主屏幕，获得类似原生应用的体验。移动端应用正在开发中，敬请期待。',
    },
  ],
  testimonials: [
    {
      name: '张伟',
      role: '资深旅行博主',
      content: '亚洲专区是我每日必读的内容平台。从东南亚美食到日本文化，内容深度和广度都令人惊叹。强烈推荐给所有对亚洲感兴趣的朋友！',
      avatar: 'https://readdy.ai/api/search-image?query=Asian%20male%20travel%20blogger%20portrait%2C%20friendly%20outdoor%20lifestyle%20photo%2C%20warm%20natural%20lighting%2C%20simple%20cream%20background&width=80&height=80&seq=testimonial-zhangwei&orientation=squarish',
    },
    {
      name: '李思涵',
      role: '跨境电商从业者',
      content: '通过亚洲专区的产品服务栏目，我发现了许多优质的亚洲产品供应商。内容专业、信息全面，对我的业务拓展帮助非常大。',
      avatar: 'https://readdy.ai/api/search-image?query=Asian%20female%20business%20professional%20portrait%2C%20modern%20office%20setting%2C%20confident%20expression%2C%20warm%20indoor%20lighting%2C%20simple%20cream%20background&width=80&height=80&seq=testimonial-lihan&orientation=squarish',
    },
    {
      name: '陈俊杰',
      role: '文化研究学者',
      content: '作为一个研究亚洲文化的学者，我欣赏亚洲专区对文化内容的深度挖掘。不仅有表面的介绍，更有对文化现象背后逻辑的深刻洞察。',
      avatar: 'https://readdy.ai/api/search-image?query=Asian%20male%20academic%20scholar%20portrait%2C%20intellectual%20look%20with%20glasses%2C%20library%20background%2C%20warm%20lighting%2C%20simple%20cream%20tone&width=80&height=80&seq=testimonial-chenjj&orientation=squarish',
    },
  ],
};